import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { CreateFileDto } from "@/core/features/file/create-file.dto";

export class UpdatePostDto {
  @Expose()
  title: string;

  @Expose()
  description: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  date: Date;

  @Expose({ name: "operativeUnitIds" })
  operativeUnits?: string[];

  @Expose()
  @Type(() => CreateFileDto)
  files?: CreateFileDto[];
}
